import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from "firebase/app";

// Add the Firebase services 
import "firebase/auth";
import "firebase/firestore";

//import ElementUI from 'element-ui';
//import 'element-ui/lib/theme-chalk/index.css';
//Vue.use(ElementUI, { locale })

import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale';

// configure language
locale.use(lang);

import {
  Card,
  DatePicker,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Switch,
  Select,
  Option,
  Button,
  ButtonGroup,
  Tabs,
  Table,
  TableColumn,
  Form,
  FormItem,
  TabPane,
  Tag,
  Alert,
  Icon,
  Row,
  Col,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  PageHeader,
  Pagination,
  Loading,
  MessageBox,
  Message,
  Notification,
  Checkbox,
} from 'element-ui';

Vue.use(locale);
Vue.use(Card);
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option),
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tag);
Vue.use(Alert);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(PageHeader);
Vue.use(Pagination)
Vue.use(Loading);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;

Vue.config.productionTip = false

// Firebase configuration
const firebaseConfig = {

  // PROD
  apiKey: "AIzaSyDCf1LX2bFOd-UspY0j8vAa7nAprLNGJVE",
  authDomain: "altera2-ecopetrol.firebaseapp.com",
  databaseURL: "https://altera2-ecopetrol.firebaseio.com",
  projectId: "altera2-ecopetrol",
  storageBucket: "altera2-ecopetrol.appspot.com",
  messagingSenderId: "542140478213",
  appId: "1:542140478213:web:f5974c94f63ed12529fd6c"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

firebase.auth().onAuthStateChanged(function(user) {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
});
